import React, { useState } from 'react';
import styled from 'styled-components';

import FormButton from '@components/form/form-button';
import Image from '@domain/image';
import Layout from '@domain/layout';
import { useVismaConfiguration } from '@services/visitor-management';

import MultipleRegistrationModal from './multiple-registration-modal';

const Container = styled.div`
  width: 60vw;

  @media only screen and (max-width: 1200px) {
    width: 100%;
    padding-bottom: 10vh;
  }
`;

const HeaderText = styled.h1`
  font-size: 30px;
  font-weight: 600;
  color: ${({ theme }) => theme.text};
  border-bottom: 1px solid ${({ theme }) => theme.border};
  padding-bottom: 16px;

  @media only screen and (max-width: 1200px) {
    margin: 16px 20px;
  }
`;

const DescText = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.textSecondary};
  margin: 24px 0;
  white-space: break-spaces;
  @media only screen and (max-width: 1200px) {
    padding: 0 20px;
  }
`;

const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto 1fr;
  gap: 1em;
  margin-top: 3em;
  @media only screen and (max-width: 1200px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

const MobileImgContainer = styled(Image)`
  display: none;
  @media only screen and (max-width: 1200px) {
    display: block;
    width: 100%;
    max-height: 30vh;
    object-fit: cover;
  }
`;

interface WelcomeProps {
  onSingleRegister: () => void;
  onMultipleRegister: () => void;
}

function Welcome({ onSingleRegister, onMultipleRegister }: WelcomeProps) {
  const { configuration } = useVismaConfiguration();
  const [modal, setModal] = useState(false);

  const featuredImageId = configuration?.intro?.featured_image?.image?.id as
    string | undefined;

  return (
    <Layout
      rightPanel={
        <Image
          id={featuredImageId}
          alt="welcome-banner"
          style={{ height: '100%', width: '100%', objectFit: 'cover' }}
        />
      }
    >
      <Container>
        <MobileImgContainer id={featuredImageId} alt="welcome-banner" />
        <MultipleRegistrationModal
          open={modal}
          onProceed={() => {
            setModal(false);
            onMultipleRegister();
          }}
          closeModal={() => setModal(false)}
        />
        <HeaderText>{configuration?.intro?.title?.value}</HeaderText>
        <DescText>{configuration?.intro?.description?.value}</DescText>
        <ButtonContainer>
          <FormButton type="primary" withRightArrow onClick={onSingleRegister}>
            {configuration?.intro?.button_single?.value}
          </FormButton>
          {configuration?.generalInformation?.is_multi === 'multi' && (
            <FormButton
              type="primary"
              withRightArrow
              onClick={() => setModal(true)}
            >
              {configuration?.intro?.button_multi?.value}
            </FormButton>
          )}
          <div />
        </ButtonContainer>
      </Container>
    </Layout>
  );
}

export default Welcome;
